{
  "welcome": "ยินดีต้อนรับสู่",
  "instructions": "แตะด้านล่างเพื่อเริ่มขั้นตอนการเช็กอิน",
  "startCheckIn": "เริ่มเช็กอิน",
  "missingWarehouseTitle": "ไม่มีข้อมูลคลังสินค้า",
  "missingWarehouseMessage": "ลิงก์ไม่ถูกต้อง ต้องมีรหัสคลังสินค้า",
  "recaptchaAttribution": "เว็บไซต์นี้ได้รับการปกป้องโดย reCAPTCHA และอยู่ภายใต้{privacyPolicy}และ{termsOfService}ของ Google",
  "recaptchaPrivacyPolicy": "นโยบายความเป็นส่วนตัว",
  "recaptchaTermsOfService": "ข้อกำหนดในการให้บริการ",
  "lookupTitle": "เพิ่มหมายเลขอ้างอิงหรือหมายเลขยืนยันเพื่อค้นหาการนัดหมายของคุณ",
  "referenceNumberLabel": "หมายเลขอ้างอิงหรือหมายเลขยืนยัน",
  "referenceNotFoundError": "หมายเลขอ้างอิงหรือหมายเลขยืนยันไม่ตรงกับการนัดหมายที่ถูกต้องใด ๆ",
  "checkIn": "เช็กอิน",
  "loadTypeLabel": "ประเภทสินค้า",
  "directionLabel": "ทิศทาง",
  "operationLabel": "การดำเนินการ",
  "dockLabel": "ท่าเทียบรถ",
  "orDivider": "หรือ",
  "noReferenceTitle": "ฉันไม่มีหมายเลขยืนยัน",
  "noReferenceDescription": "ดำเนินการต่อโดยไม่มีการนัดหมายด้วยขั้นตอนการเช็กอินมาตรฐาน",
  "checkInWithoutAppointment": "เช็กอินโดยไม่มีการนัดหมาย",
  "readyToCheckInTitle": "พร้อมเช็กอินหรือยัง?",
  "readyToCheckInDescription": "แตะด้านล่างเพื่อเริ่ม คุณจะกรอกรายละเอียดในหน้าจอถัดไป",
  "referenceRequiredHint": "ต้องใช้หมายเลขอ้างอิงเพื่อเช็กอินที่สถานที่นี้",
  "haveAppointment": "ฉันมีการนัดหมาย",
  "direction": {
    "inbound": "ขาเข้า",
    "outbound": "ขาออก",
    "inOut": "ขาเข้าและขาออก",
    "load": "ขนขึ้น",
    "unload": "ขนลง"
  },
  "operation": {
    "live": "รอขนถ่าย (Live)",
    "drop": "ปลดทิ้งไว้ (Drop)",
    "other": "อื่น ๆ"
  }
}
